import { Injectable, OnDestroy } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthenticatedUserViewModel } from '../../models/logins';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { Subscription } from 'rxjs/internal/Subscription';
import { SingletonCheckHelper } from '../../helpers/singleton-check.helper';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class AuthenticationStorageService implements OnDestroy {

    onCurrentUserChanged$: Observable<AuthenticatedUserViewModel>;

    private readonly _currentUserKey = 'CurrentUser';

    private readonly _currentUser: BehaviorSubject<AuthenticatedUserViewModel>;

    private currentUserJson: string;

    private localStorageMonitorSubscription: Subscription;

    constructor(
        private localStorageService: LocalStorageService
    ) {

        SingletonCheckHelper.ensureSingleton(this);

        this.currentUserJson = this.getUserFromLocalStorageJson();

        const currentUser = this.currentUserJson ? JSON.parse(this.currentUserJson) : null;

        this._currentUser = new BehaviorSubject<AuthenticatedUserViewModel>(currentUser);

        this.onCurrentUserChanged$ = this._currentUser.asObservable();

        const derivedKey = this.localStorageService.retrieve(this._currentUserKey);

        const localStorageEvent = fromEvent(window, 'storage')
            .pipe(
                filter((x: any) => x.storageArea == localStorage && x.key === derivedKey), // this had StorageEvent type for X
                map((x: StorageEvent) => {
                    return x.newValue;
                })
            );

        this.localStorageMonitorSubscription = localStorageEvent.subscribe(x => {
            if (x != this.currentUserJson) {

                this.currentUserJson = x;

                this.fireUserChanged();
            }
        });

        // interval(1000).subscribe(x => {
        //     const userJson = this.getUserFromLocalStorageJson();

        //     if (userJson != this.currentUserJson) {

        //         this.currentUserJson = userJson;

        //         this.fireUserChanged();
        //     }
        // })
    }

    ngOnDestroy(): void {
        this.localStorageMonitorSubscription.unsubscribe();
    }

    getCurrentUser(): AuthenticatedUserViewModel {
        return this.localStorageService.retrieve(this._currentUserKey);
    }

    setCurrentUser(currentUser: AuthenticatedUserViewModel) {

        this.localStorageService.store(this._currentUserKey, currentUser);

        const currentUserJson = currentUser ? JSON.stringify(currentUser) : null;

        if (this.currentUserJson != currentUserJson) {
            this.currentUserJson = currentUserJson;

            this._currentUser.next(currentUser);
        }
    }

    private fireUserChanged() {
        const currentUser = this.currentUserJson ? JSON.parse(this.currentUserJson) : null;

        this._currentUser.next(currentUser);
    }

    private getUserFromLocalStorageJson() {
      const fullKey = this.localStorageService.retrieve(this._currentUserKey);

      return localStorage.getItem(fullKey);
    }
}
